import { getProjectIntegrations } from '@lib/api'
import { projectIntegrationsKeys } from '@lib/keys'
import { useQuery } from '@tanstack/react-query'

export const useProjectIntegrations = () => {
  return useQuery(projectIntegrationsKeys.all, () => getProjectIntegrations())
}
